import { ThingEventSnapshot } from '@eagle/core-data-types';
import { CacheDataTypes, getThreshold, useBoolFlag, useCustomRoutes, useNumberFlag } from '@eagle/react-common';
import { Button } from '@ethings/ui-toolkit';
import { Box } from '@mui/material';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { buildTripsCoreHistoryRange, HISTORY_CUSTOM_DATE_RANGE_FLAG, resolveTripHistoryMaxRangeHours, TRIPS_CORE_EXPERIENCE_FLAG } from '../../history/history-date-range.utils';
import { buildThingEventHistoryReferenceData } from './thing-event-history-navigation';

export const ThingEventInvestigateButton: FC<{ event: ThingEventSnapshot; filters?: string[] }> = ({ event, filters }) => {
  const { t } = useTranslation(['track']);
  const date = DateTime.fromJSDate(event.timing.received);
  const threshold = getThreshold(event.eventTypeId);
  const navigate = useNavigate();
  const { history: customRoutesHistory } = useCustomRoutes();
  const flagTripsCoreExperience = useBoolFlag(TRIPS_CORE_EXPERIENCE_FLAG);
  const maxHistoryCustomDateRangeHours = useNumberFlag(HISTORY_CUSTOM_DATE_RANGE_FLAG);

  const onClick = (): void => {
    const maxRangeHours = resolveTripHistoryMaxRangeHours(maxHistoryCustomDateRangeHours);
    const tripsCoreRange = buildTripsCoreHistoryRange(date, maxRangeHours);

    navigate(`/${customRoutesHistory}`,
      {
        state: {
          dateEnd: flagTripsCoreExperience ? tripsCoreRange.dateEnd : date.plus({ minutes: threshold.end }).toJSDate(),
          dateStart: flagTripsCoreExperience ? tripsCoreRange.dateStart : date.minus({ minutes: threshold.start }).toJSDate(),
          entityId: event.thingId,
          entityItemFields: {
            entity: CacheDataTypes.THING,
            entityType: CacheDataTypes.THING_TYPE,
            entityTypeKey: 'thingTypeId',
          },
          filters: filters ?? [],
          focused: true,
          ...(flagTripsCoreExperience ? { referenceData: buildThingEventHistoryReferenceData(event) } : {}),
        },
      },
    );
  };

  return (
    <Box
      sx={{ mx: 1, mb: 1, justifyContent: 'flex-start' }}
    >
      <Button
        data-testid="more-details-button"
        onClick={onClick}
        size="small"
        variant="text"
      >
        {t('common:component.events.thing-event.labels.table.more-details')}
      </Button>
    </Box>
  );
};
